import React, { useState } from 'react';
import { FaEnvelopeOpenText } from 'react-icons/fa'; // Make sure to install: npm install react-icons

const ContactForm = () => {
  const [subject, setSubject] = useState('');
  const [message, setMessage] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();

    const mailtoLink = `mailto:admin@panafricanbookexchange-wandererspath.com?subject=${encodeURIComponent(
      subject
    )}&body=${encodeURIComponent(message)}`;

    window.location.href = mailtoLink;
  };

  return (
    <div style={styles.wrapper}>
      <form onSubmit={handleSubmit} style={styles.form}>
        <div style={styles.iconWrapper}>
          <FaEnvelopeOpenText size={40} color="#4B9CD3" />
        </div>
        <h2 style={styles.title}>Get in Touch with Admin</h2>
        <p style={styles.subtitle}>We'd love to hear from you.</p>

        <input
          type="text"
          placeholder="Subject"
          value={subject}
          onChange={(e) => setSubject(e.target.value)}
          required
          style={styles.input}
        />
        <textarea
          placeholder="Write your message..."
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          required
          style={styles.textarea}
        />
        <button type="submit" style={styles.button}>Send Email</button>
      </form>
    </div>
  );
};

const styles = {
  wrapper: {
    minHeight: '100vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    background: 'linear-gradient(135deg, #f4f9ff, #e2ecf9)',
    padding: '40px 20px',
  },
  form: {
    background: '#ffffff',
    padding: '40px',
    borderRadius: '16px',
    boxShadow: '0 12px 30px rgba(0, 0, 0, 0.08)',
    maxWidth: '600px',
    width: '100%',
    fontFamily: 'Segoe UI, sans-serif',
  },
  iconWrapper: {
    textAlign: 'center',
    marginBottom: '20px',
  },
  title: {
    textAlign: 'center',
    color: '#2b2b2b',
    fontSize: '24px',
    marginBottom: '8px',
  },
  subtitle: {
    textAlign: 'center',
    color: '#777',
    marginBottom: '24px',
    fontSize: '15px',
  },
  input: {
    width: '100%',
    padding: '14px',
    marginBottom: '18px',
    borderRadius: '8px',
    border: '1px solid #ccc',
    fontSize: '16px',
    transition: 'all 0.3s ease',
    outline: 'none',
  },
  textarea: {
    width: '100%',
    height: '160px',
    padding: '14px',
    marginBottom: '24px',
    borderRadius: '8px',
    border: '1px solid #ccc',
    fontSize: '16px',
    transition: 'all 0.3s ease',
    outline: 'none',
  },
  button: {
    backgroundColor: '#45a049',
    color: '#fff',
    border: 'none',
    padding: '14px 20px',
    borderRadius: '8px',
    cursor: 'pointer',
    fontSize: '16px',
    width: '100%',
    transition: 'background 0.3s ease',
  },
};

export default ContactForm;
